
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import AttachmentIcon from '@/components/icons/AttachmentIcon.vue';
import SendMessageIcon from '@/components/icons/SendMessageIcon.vue';
import { analytics, GENERAL_EVENTS } from '@/common/logs';
import { parseErrorMessage } from '@/common/error';

@Component({ components: { AttachmentIcon, SendMessageIcon } })
export default class Input extends Vue {
  @Prop({ default: '' }) readonly addClass!: string;
  @Prop({ default: '' }) readonly placeholder!: string;
  @Prop(Boolean) readonly isAbleToSendMsg!: boolean;
  @Prop({ type: Boolean, default: true }) readonly showFileUpload!: boolean;
  @Prop({ type: Number, default: 0 }) readonly charsWhenShowLimit!: number;
  @Prop({ type: Number, default: 5000 }) readonly messageLengthLimit!: number;

  dragover = false;
  message = '';
  readonly allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png'];

  get getClass () {
    return ['input-container', this.addClass, this.dragover ? 'drag-drop-zone' : ''];
  }
  get validMessage () {
    return this.isAbleToSendMsg && this.message.replace(/\s/g, '').length > 0 && this.message.length <= this.messageLengthLimit;
  }

  get placeHolderContent () {
    if (!this.placeholder) return this.$t('chat.input.placeholder');
    return this.placeholder;
  }

  async selectImage (event: any) {
    if (!this.isAbleToSendMsg || !event.target.files.length) return;
    const imageFile = event.target.files[0];
    const MAX_FILE_SIZE = 5 * 1024 * 1044;

    try {
      const file = event.target.files[0];
      const attachment = {
        mime_type: file.type,
        name: file.name,
        size: file.size,
        url: window.URL.createObjectURL(file),
      };

      if (attachment.size > MAX_FILE_SIZE) {
        analytics.track({
          name: GENERAL_EVENTS.FILE_UPLOAD_SIZE_EXCEEDED,
          metadata: attachment,
        });

        const dialog = this.$dialog({
          content: 'File size cannot exceed 5 MB',
          buttons: [{
            name: 'OK',
            callback: () => { dialog.close(); },
          }],
        });
        return;
      }
      
      this.$emit('onFileUpload', file, attachment);
    } catch (error) {
      console.log(error);
      analytics.track({
        name: GENERAL_EVENTS.FILE_UPLOAD_ERROR,
        metadata: { error: parseErrorMessage(error) },
      });

      const dialog = this.$dialog({
        content: 'Error occurred while uploading file, please try again or select another file.',
        buttons: [{
          name: 'OK',
          callback: () => { dialog.close(); },
        }],
      });
    }
  }
  isValidMimeType (str: string) {
    return this.allowedMimeTypes.includes(str);
  }
  onSubmit () {
    if (!this.isAbleToSendMsg || !this.validMessage) return;
    this.$emit('onSubmit', this.message);
    this.message = '';
  }
  @Watch('message')
  onChange () {
    this.$emit('typing', this.message);
  }
  autoExpand (event: any) {
    const defaultHeight = 32;
    const field = event.target;
    if (!/\n/.test(this.message)) {
      field.style.height = `${defaultHeight}px`;
      return;
    };
    // Reset field height
    const curHeight = field.style.height;
    field.style.height = 'inherit';
    // Get the computed styles for the element
    const computed = window.getComputedStyle(field);
    // Calculate the height
    const height = parseInt(computed.getPropertyValue('border-top-width'), 10) +
      parseInt(computed.getPropertyValue('padding-top'), 10) +
      field.scrollHeight +
      parseInt(computed.getPropertyValue('padding-bottom'), 10) +
      parseInt(computed.getPropertyValue('border-bottom-width'), 10);

    field.style.height = (height > 90 && curHeight) ? curHeight : `${height}px`;
  }
}
